import { render, staticRenderFns } from "./TheHero.vue?vue&type=template&id=4b9c6422&scoped=true&"
import script from "./TheHero.vue?vue&type=script&lang=js&"
export * from "./TheHero.vue?vue&type=script&lang=js&"
import style0 from "./TheHero.vue?vue&type=style&index=0&id=4b9c6422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9c6422",
  null
  
)

export default component.exports